module.exports = __webpack_public_path__ + "img/ai_video.1731d0cc.jpg";